export enum NodeStatus {
  GHOST = "ghost",          // 👻 Blueprint only
  PENDING = "pending",      // ⏳ Queued for generation
  HYDRATING = "hydrating",  // 🌀 Agent is working
  FRESH = "fresh",          // 🟢 Content exists & synced
  STALE = "stale",          // 🟡 Upstream dependency changed
  LOCKED = "locked"         // 🔒 User override
}

export interface ArtifactoryNode {
  id: string;
  name: string;
  path: string;
  type: "file" | "directory";
  status: NodeStatus;

  // Intelligence
  assigned_persona_id: string;
  generation_prompt: string;

  // Topology
  dependencies: string[]; // IDs of other nodes
  dependents?: string[];  // IDs of nodes that depend on this

  // Materialization
  artifact_id?: string;   // Link to actual content
  last_hydrated?: string;

  // Metadata (hydration_count, last_hydration, etc.)
  metadata?: Record<string, unknown>;
}

export type AssetKind = 'artifact_ref' | 'external_ref' | 'inline_snippet';

export interface ProjectAsset {
  id: string;
  kind: AssetKind;
  name: string;
  usage_note: string;
  artifact_id?: string;
  url?: string;
  content?: unknown;
}

export interface IntentHistoryEntry {
  id: string;
  content: string;
  timestamp?: string;
  mutation_reason?: string | null;
  user_prompt: string;
  affected_nodes: string[];
}

export interface ProjectManifest {
  id: string; // The Artifact ID containing this manifest
  root_context: string;
  original_intent?: string;
  intent_history?: IntentHistoryEntry[];
  nodes: Record<string, ArtifactoryNode>;
  assets?: ProjectAsset[];
  version: number;
  metadata?: Record<string, unknown>;
}

export interface HandoffPlugin {
  name: string;
  display_name: string;
  icon: string;
  description: string;
  instruction_filename: string;
  has_config_dir: boolean;
  has_skills: boolean;
}

export interface HandoffOptions {
  includeStale?: boolean;
  includeGhost?: boolean;
  includeBuildOrder?: boolean;
  includeIntentHistory?: boolean;
}
